// Los seis cursos, también en el navegador.
//
// POR QUE ESTAN DOS VECES. La lista de verdad es la del servidor
// (`backend/app/domain/etapa.py`): es la que valida lo que llega y la que decide qué se
// guarda. Ésta existe porque el desplegable del registro tiene que pintarse **antes de que
// haya cuenta**, y pedirle la lista al servidor para dibujar un `<select>` significa que un
// fallo de red deja el formulario sin cursos y a nadie registrándose.
//
// Y por eso hay un portero: `tools/prueba_etapa.py` ejecuta las dos y se cae si difieren en
// una clave o en un nombre. Dos copias que nadie compara se separan siempre.

// Y CADA UNA LLEVA UN NOMBRE CORTO ADEMÁS DEL LARGO, desde el 8 de octubre de 2026. El largo
// es el del desplegable del registro, donde se elige una vez y con calma; el corto es para una
// lista de cursos, donde va al final de cada fila y repetido veinte veces. **«1.º de
// Bachillerato» veinte veces es una columna de ruido**; «1.º bach», una pista. No es otra lista:
// es una columna más de ésta, para que no nazca un segundo mapa de etapas en un componente.
export const ETAPAS = [
  { clave: "1eso", nombre: "1.º de la ESO", corto: "1.º ESO" },
  { clave: "2eso", nombre: "2.º de la ESO", corto: "2.º ESO" },
  { clave: "3eso", nombre: "3.º de la ESO", corto: "3.º ESO" },
  { clave: "4eso", nombre: "4.º de la ESO", corto: "4.º ESO" },
  { clave: "1bach", nombre: "1.º de Bachillerato", corto: "1.º bach" },
  { clave: "2bach", nombre: "2.º de Bachillerato", corto: "2.º bach" },
];

/**
 * PARA QUIÉN ES UN CURSO, EN UNA ETIQUETA. Una clave sola da su nombre corto; varias, el tramo
 * de la primera a la última en el orden de la lista —«3.º ESO – 1.º bach»—, que es más corto y más
 * cierto que enumerarlas.
 *
 * Y SIN ETAPAS DEVUELVE CADENA VACÍA, no «para todos»: un curso que no dice para quién es no
 * está diciendo que sea para cualquiera, y la pantalla tiene que poder no pintar nada. Es la
 * misma decisión que toma `filtra()` al dejarlo salir siempre.
 */
export function etiquetaDeEtapas(claves) {
  const hay = ETAPAS.filter((e) => (claves || []).includes(e.clave));
  if (hay.length === 0) return "";
  if (hay.length === 1) return hay[0].corto;
  return `${hay[0].corto} – ${hay[hay.length - 1].corto}`;
}

// Y EL GUION LLEVA AIRE A LOS DOS LADOS desde el 17 de octubre de 2026. Gabri, viendo la
// píldora de una tarjeta: *«añade un espacio antes y después del guion»*. Pegado —«1.º ESO–2.º
// bach»— las dos etapas se leen como una palabra larga y el ojo no encuentra dónde empieza la
// segunda; en mayúsculas y con el espaciado de la mono, todavía peor.

/** La clave si existe, `null` si no. `null` no es «1.º de la ESO»: es «no ha contestado». */
export function valida(clave) {
  if (typeof clave !== "string") return null;
  const c = clave.trim().toLowerCase();
  return ETAPAS.some((e) => e.clave === c) ? c : null;
}
